import { chakra } from '@chakra-ui/react'

import { shouldForwardProp } from 'src/utils/should-forward-prop'
import {
    PARAGRAPH_METADATA_DESKTOP_FONT_SIZE_COEFF,
    PARAGRAPH_METADATA_LINE_HEIGHT_COEFF,
    PARAGRAPH_METADATA_MOBILE_FONT_SIZE_COEFF,
} from 'src/components/TranscriptViewer/ParagraphView/constants'

const TIMESTAMP_SCALE_COEFF = 0.85

type TimestampProps = { $color: string; $minWidth: number }
export const Timestamp = chakra<'div', TimestampProps>('div', {
    baseStyle: ({ $color, $minWidth, theme }) => ({
        fontFamily: 'inherit',
        fontSize: `${PARAGRAPH_METADATA_DESKTOP_FONT_SIZE_COEFF * TIMESTAMP_SCALE_COEFF}em`,
        fontWeight: 500,
        lineHeight: PARAGRAPH_METADATA_LINE_HEIGHT_COEFF,
        color: $color,
        textTransform: 'uppercase',
        userSelect: 'none',
        pointerEvents: 'none',
        minWidth: `${$minWidth}em`,
        [`@container (max-width: ${theme.breakPoints.tabletMaxWidth}px)`]: {
            fontSize: `${PARAGRAPH_METADATA_MOBILE_FONT_SIZE_COEFF}em`,
        },
    }),
    shouldForwardProp,
})
